import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";

// Plugins
import App from "./App.vue";
import Chartist from "chartist";

// router setup
import { router } from '@/router';
import { store } from '@/_store';

import Loading from "vue-loading-overlay";
import { VueReCaptcha } from "vue-recaptcha-v3";


// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(require('vue-moment'));
Vue.use(Loading);
Vue.use(VueReCaptcha, { siteKey: "6LfO2L4UAAAAAKXbxM7nyn8Q6paz1tw3Efabpm_X" });

// global library setup
Object.defineProperty(Vue.prototype, "$Chartist", {
  get() {
    return this.$root.Chartist;
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store,
  data: {
    Chartist: Chartist
  }
});
